"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lucide_1 = require("lucide");
const event_1 = require("@/common/event");
const ui_1 = require("@/ui/ui");
const form_1 = require("@/ui/form/form");
const i18n_1 = require("@/common/i18n");
const modal_1 = require("./modal");
class ManagerModal extends modal_1.Modal {
    constructor(target) {
        super(target, { id: "manager", title: (0, i18n_1.$)("modal.manager.title"), icon: lucide_1.Box, width: 600 });
        this._listItems = [];
        this._currentObject = null;
        // this._addFooterButton("clear", { text: $("modal.manager.clear"), variant: "danger", icon: Trash2 }, "left", () => {});
        this._addFooterButton("save", { text: (0, i18n_1.$)("modal.manager.save"), variant: "success", icon: lucide_1.Check }, "right", () => this._save());
        this._addFooterButton("apply", { text: (0, i18n_1.$)("modal.manager.apply"), variant: "success" }, "right", () => this._apply());
        this._addFooterButton("cancel", { text: (0, i18n_1.$)("modal.manager.cancel"), variant: "secondary" }, "right", () => this.close());
        // UI
        this._listElem = this._container.appendChild((0, jsx_runtime_1.jsx)("div", { className: "object-list" }));
        this._form = new form_1.Form(this._container);
        this._register(this.onShow(({ objects }) => {
            this._objects = objects;
            for (const obj of this._objects) {
                const isFirst = obj === this._objects[0];
                const item = new ObjectListItem(this._listElem, { id: obj.id, name: obj.name, obj, isDefault: isFirst });
                this._listItems.push(item);
                if (isFirst)
                    this._setObjectPage(obj);
                item.onClick(() => {
                    this._setObjectPage(obj);
                    for (const listItem of this._listItems) {
                        if (listItem !== item) {
                            listItem.setActive(false);
                        }
                    }
                });
            }
        }));
        this._register(this.onClose(() => {
            this._reset();
        }));
    }
    _setObjectPage(obj) {
        this._clearObjectPage();
        this._currentObject = obj;
        this._form.registerList(obj.getSettingsList());
    }
    _clearObjectPage() {
        this._currentObject = null;
        this._form.unregisterList();
    }
    _apply() {
        this._currentObject.applySettings(this._form.submit());
    }
    _save() {
        this._apply();
        this.close();
    }
    _reset() {
        this._clearObjectPage();
        for (const listItem of this._listItems) {
            listItem.dispose();
        }
        this._listItems = [];
    }
    dispose() {
        this._reset();
        super.dispose();
    }
}
exports.ManagerModal = ManagerModal;
const objectListItemDefaultOptions = {
    id: "",
    name: "",
    obj: null,
    isDefault: false
};
class ObjectListItem extends ui_1.Component {
    constructor(target, _options) {
        super(((0, jsx_runtime_1.jsxs)("div", { className: "object-list-item", children: [(0, jsx_runtime_1.jsx)("span", { className: "object-name", children: _options.name }), (0, jsx_runtime_1.jsxs)("span", { className: "object-id", children: ["ID: ", _options.id] })] })), target, objectListItemDefaultOptions, _options);
        // events
        this._onClick = new event_1.Emitter();
        this._isActive = false;
        if (this._options.isDefault)
            this.setActive(true);
        this._element.addEventListener("click", () => {
            this.setActive(true);
            this._onClick.fire();
        });
        this._register(this._onClick);
    }
    setActive(isActive) {
        this._isActive = isActive;
        if (this._isActive) {
            this._element.classList.add("active");
        }
        else {
            this._element.classList.remove("active");
        }
    }
    get onClick() {
        return this._onClick.event;
    }
}
